import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SubscriptionFinalStatus, SubscriptionType, TableDataType } from "@app/shared/enums/common.enums";
import SubscriptionHelper from "@app/shared/utilities/subscription.helper";

@Component({
    selector: 'app-subscription-detail',
    templateUrl: './subscription-detail.component.html',
    standalone: false
})
  export class SubscriptionDetailComponent {  
    @Input() subscriptionStatusId?: number; 
    @Input() subscriptionType?: number | null = null; 
    @Input() subscriptionEndDate?: Date; 
    @Input() showHistoryPayment: boolean = false;
    @Output() onPaymentHistory: EventEmitter<any> = new EventEmitter<any>();
    SubscriptionFinalStatus = SubscriptionFinalStatus;
    subscription!: SubscriptionFinalStatus;
    TableDataType = TableDataType;

    ngOnInit() {
      this.subscription = SubscriptionHelper.getSubscriptionFinalStatus(this.subscriptionStatusId, this.subscriptionType, this.subscriptionEndDate);
    }

    getSubscriptionStatusClass(statusId: number): string {
      return SubscriptionHelper.getStatusClass(statusId);
    }

    getSubscriptionStatusIcon(statusId: number): string {
      return SubscriptionHelper.getStatusIcon(statusId);
    }

    getSubscriptionStatusButton(statusId: number): string {
      return SubscriptionHelper.getStatusButton(statusId);
    }
  }